export class EmployeesListLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            name: lang.course[1],
            sno: lang.course[109],
            subject: lang.course[54],
            text: lang.course[153],
            date: lang.course[148],
            notification: lang.course[128],
            action: lang.course[28],
            selectColumns: lang.general[9],
            selectAll: lang.general[10],
            activeColumns: lang.general[11],
            close: lang.general[17],
            exportCsv: lang.general[13],
            exportPdf: lang.general[14],
            exportExcel: lang.general[15],
            print: lang.general[16],
            humanResources: lang.general[42],
            view: lang.general[3],
            erase: lang.general[4],
            select_type: lang.course[155],
            import: lang.course[65],
            todownloadtocsv: lang.course[51],
            save: lang.general[0],
            employees: lang.course[107],
            list: lang.course[293],
            surname: lang.course[23],
            age: lang.course[262],
            email: lang.course[110],
            phone: lang.course[111],
            task: lang.course[113],
            qualifications: lang.course[114],
            assumptionData: lang.course[131],
            status: lang.course[62],
            create:lang.course[180],
            employee: lang.course[108],
            requiredField: lang.general[26],
            editEmployee:lang.course[216],
            taxCode:lang.course[129],
            dateofBirth:lang.course[25],
            placeofBirth:lang.course[26],
            address:lang.course[130],
            titleofStudy:lang.course[132],
            hourlyCost:lang.course[133],
            all:lang.course[288],
            active:lang.course[289],
            resigned:lang.course[290],
            selectStatus:lang.course[285],
            pleaseenteronlydigits:lang.course[335],
            skillCode:lang.course[297],
            repetition:lang.course[191],
            description:lang.course[147],
            notificationTime:lang.course[197],
            levelofcompetence:lang.course[298],
            employeeToWhichSkillApplies:lang.course[299],
            modify:!(lang.general[117])?lang.general[2]:lang.general[117],
            hired_emp:lang.course[336],
            reasigned_emp:lang.course[337],
            skills: lang.general[81],
            skills_analysis:lang.course[294],
            courses_list:lang.course[276],
            search_for_courses:lang.course[277],
            courses_status:lang.course[295],
            create_dept:lang.course[305],
            edit_dept:lang.course[338],
            code:lang.course[306],
            desc:lang.course[147],
            how_often_repeat:lang.course[301],
            notify_time:lang.course[197],
            level_of_competence:lang.course[298],
            employee_to_which_skilss:lang.course[299],
            ref_mail:lang.course[228],
            select:lang.general[67],
            select_all:lang.general[10],
            un_select_all:lang.general[111],
            distribution_status:lang.course[267],
            send_to:lang.course[265],
            date_send:lang.course[268],
            insert_skill_analysis:lang.course[308],
            title:lang.course[122],
            course_type:lang.course[2],
            duration_hours:lang.course[3],
            part:lang.course[53],
            name_of_participants:lang.course[334],
            place:lang.course[8],
            start_date:lang.course[9],
            end_date:lang.course[10],
            applicable_skills:lang.course[316],
            teacher:lang.course[60],
            course_code:lang.course[339],
            employee_name:lang.course[279],
            employee_sur_name:lang.course[280],
            tax_code:lang.course[129],
            certificate:lang.course[30],
            search:lang.general[33],
            status_of_the_course:lang.course[7],
            cost:lang.course[15],
            duration:lang.course[3],
            topic:lang.course[5],
            available_skills:lang.course[314],
            responsible:lang.course[11],
            teaching_material:lang.course[6],
            list_of_attendes:lang.course[17],
            dob:lang.course[25],
            place_of_birth:lang.course[26],
            fiscal_code:lang.course[27],
            outcome:lang.course[29],
            positive:lang.course[31],
            negative:lang.course[32],
            add_people:lang.course[121],
            course_sheet:lang.course[343],
            
        }

    }

    lang() {
        return this.variables;
    }

}
export class EmployeesGeneralLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            name: lang.course[1],
            sno: lang.course[109],
            subject: lang.course[54],
            text: lang.course[153],
            date: lang.course[148],
            notification: lang.course[128],
            action: lang.course[28],
            selectColumns: lang.general[9],
            selectAll: lang.general[10],
            activeColumns: lang.general[11],
            close: lang.general[17],
            exportCsv: lang.general[13],
            exportPdf: lang.general[14],
            exportExcel: lang.general[15],
            print: lang.general[16],
            humanResources: lang.general[42],
            view: lang.general[3],
            erase: lang.general[4],
            requiredField:lang.general[26],
            addNotification:lang.course[266],
            type:lang.course[135],
            description:lang.course[147],
            notes:lang.course[149],
            attachments:lang.course[150],
            save:lang.course[80],
            select_type:lang.course[155],
            communication:lang.course[186],
            consultation:lang.course[187],
            other:lang.course[188],
            create:lang.course[180],

        }

    }

    lang() {
        return this.variables;
    }

}
export class EmployeeCreateLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            name: lang.course[1],
            sno: lang.course[109],
            subject: lang.course[54],
            text: lang.course[153],
            date: lang.course[148],
            notification: lang.course[128],
            action: lang.course[28],
            selectColumns: lang.general[9],
            selectAll: lang.general[10],
            activeColumns: lang.general[11],
            close: lang.general[17],
            exportCsv: lang.general[13],
            exportPdf: lang.general[14],
            exportExcel: lang.general[15],
            print: lang.general[16],
            humanResources: lang.general[42],
            view: lang.general[3],
            erase: lang.general[4],
            requiredField:lang.general[26],
            addNotification:lang.course[266],
            type:lang.course[135],
            description:lang.course[147],
            notes:lang.course[149],
            attachments:lang.course[150],
            save:lang.course[80],
            select_type:lang.course[155],
            communication:lang.course[186],
            consultation:lang.course[187],
            other:lang.course[188],
            create:lang.course[180],
            surname:lang.course[23],
            address:lang.course[130],
            taxCode:lang.course[129],
            phone:lang.course[111],
            dateofBirth:lang.course[25],
            email:lang.course[110],
            placeofBirth:lang.course[26],
            assumptionDate:lang.course[131],
            task:lang.course[24],
            hourlyCost:lang.course[133],
            qualifications:lang.course[114],
            skills:lang.course[291],
            titleofStudy:lang.course[132],
            status:lang.course[333],
            photo:lang.course[112],
            pleaseSelect:lang.course[173],
            editEmployee:lang.course[216],

        }

    }

    lang() {
        return this.variables;
    }

}

export class EmployeesViewLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            courseCode: lang.course[0],
            name: lang.course[1],
            sno: lang.course[109],
            subject: lang.course[54],
            text: lang.course[153],
            date: lang.course[148],
            notification: lang.course[128],
            action: lang.course[28],
            selectColumns: lang.general[9],
            selectAll: lang.general[10],
            activeColumns: lang.general[11],
            close: lang.general[17],
            exportCsv: lang.general[13],
            exportPdf: lang.general[14],
            exportExcel: lang.general[15],
            print: lang.general[16],
            humanResources: lang.general[42],
            view: lang.general[3],
            erase: lang.general[4],
            select_type: lang.course[155],
            import: lang.course[65],
            todownloadtocsv: lang.course[51],
            save: lang.general[0],
            employees: lang.course[107],
            list: lang.course[293],
            surname: lang.course[23],
            age: lang.course[262],
            email: lang.course[110],
            phone: lang.course[111],
            task: lang.course[113],
            qualifications: lang.course[114],
            assumptionData: lang.course[131],
            status: lang.course[62],
            create:lang.course[180],
            employee: lang.course[108],
            requiredField: lang.general[26],
            editEmployee:lang.course[216],
            taxCode:lang.course[129],
            dateofBirth:lang.course[25],
            placeofBirth:lang.course[26],
            address:lang.course[130],
            titleofStudy:lang.course[132],
            hourlyCost:lang.course[133],
            courseAttended:lang.course[134],
            type:lang.course[135],
            durationHours:lang.course[3],
            startDate:lang.course[9],
            endDate:lang.course[10],
            teacher:lang.course[60],
            outcome:lang.course[29],
            certificate:lang.course[30],
            uploadCertificate:lang.course[34],
            description:lang.course[147],
            notes:lang.course[149],
            attachments:lang.course[150],
            addprotectivedevice:lang.course[154],
            editprotectivedevice:lang.course[164],
            deviceName:lang.course[140],
            brand:lang.course[159],
            model:lang.course[160],
            partofthebodyprotected:lang.course[161],
            dateAssignment:lang.course[141],
            thirdCatergory:lang.course[263],
            addDpi:lang.course[139],
            modify:lang.general[2],
            emp_view:lang.course[123],
            personal_data:lang.course[214],
            docs:lang.general[51],
            training:lang.course[72],
            medical_examination:lang.general[45],
            dpi:lang.general[126],
            exam_date:lang.course[226],
            expiry_date: lang.course[329],
            curriculum: lang.course[327],
            identity_pappers: lang.course[328],
            driver_license: lang.course[330],
            contract: lang.course[332],
            list_of_delivery_report: lang.course[145],
            add_delivery_report: lang.course[146],
            first_second_category: lang.course[138],
            add_dpi: lang.course[139],
            device_name: lang.course[140],
            date_assignment: lang.course[141],
            part_of_body: lang.course[161],
            // part_of_body: lang.course[161],
            


        }

    }

    lang() {
        return this.variables;
    }

}

export class EmployeesDpiLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            courseCode: lang.course[0],
            name: lang.course[1],
            sno: lang.course[109],
            subject: lang.course[54],
            text: lang.course[153],
            date: lang.course[148],
            notification: lang.course[128],
            action: lang.course[28],
            selectColumns: lang.general[9],
            selectAll: lang.general[10],
            activeColumns: lang.general[11],
            close: lang.general[17],
            exportCsv: lang.general[13],
            exportPdf: lang.general[14],
            exportExcel: lang.general[15],
            print: lang.general[16],
            humanResources: lang.general[42],
            view: lang.general[3],
            erase: lang.general[4],
            select_type: lang.course[155],
            import: lang.course[65],
            todownloadtocsv: lang.course[51],
            save: lang.general[0],
            employees: lang.course[107],
            list: lang.course[293],
            surname: lang.course[23],
            age: lang.course[262],
            email: lang.course[110],
            phone: lang.course[111],
            task: lang.course[113],
            qualifications: lang.course[114],
            assumptionData: lang.course[131],
            status: lang.course[62],
            create:lang.course[180],
            employee: lang.course[108],
            requiredField: lang.general[26],
            editEmployee:lang.course[216],
            taxCode:lang.course[129],
            dateofBirth:lang.course[25],
            placeofBirth:lang.course[26],
            address:lang.course[130],
            titleofStudy:lang.course[132],
            hourlyCost:lang.course[133],
            courseAttended:lang.course[134],
            type:lang.course[135],
            durationHours:lang.course[3],
            startDate:lang.course[9],
            endDate:lang.course[10],
            teacher:lang.course[60],
            outcome:lang.course[29],
            certificate:lang.course[30],
            uploadCertificate:lang.course[34],
            description:lang.course[147],
            notes:lang.course[149],
            attachments:lang.course[150],
            exam_date:lang.course[226],
            addprotectivedevice:lang.course[154],
            editprotectivedevice:lang.course[164],
            deliveryDate:lang.course[158],
            brand:lang.course[159],
            model:lang.course[160],
            partofthebodyprotected:lang.course[161],


        }

    }

    lang() {
        return this.variables;
    }

}
